export type CpiFilterOperator = 'MAIOR_OU_IGUAL_A' | 'MENOR_OU_IGUAL_A' | 'ENTRE';

export type CpiFilterState = {
  operator: CpiFilterOperator;
  from: string;
  to: string;
};

export type CpiFilterApiValue = {
  operator: 'GTE' | 'LTE' | 'BETWEEN';
  from: number;
  to: number;
};

export type CpiFilterValidation = {
  canApply: boolean;
  message: string | null;
};

const OPERATOR_TO_API: Record<CpiFilterOperator, CpiFilterApiValue['operator']> = {
  MAIOR_OU_IGUAL_A: 'GTE',
  MENOR_OU_IGUAL_A: 'LTE',
  ENTRE: 'BETWEEN',
};

export const DEFAULT_CPI_FILTER_STATE: CpiFilterState = {
  operator: 'MAIOR_OU_IGUAL_A',
  from: '100',
  to: '',
};

export const isBetween = (operator: CpiFilterOperator): boolean => operator === 'ENTRE';

const parseNumber = (value: string): number | null => {
  const trimmed = value.trim();
  if (trimmed === '') {
    return null;
  }
  const parsed = Number(trimmed.replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : null;
};

export const validateCpiFilter = (state: CpiFilterState): CpiFilterValidation => {
  const from = parseNumber(state.from);
  if (from === null) {
    return { canApply: false, message: null };
  }
  if (!isBetween(state.operator)) {
    return { canApply: true, message: null };
  }
  const to = parseNumber(state.to);
  if (to === null) {
    return { canApply: false, message: null };
  }
  if (to <= from) {
    return { canApply: false, message: 'O segundo valor deve ser maior que o primeiro.' };
  }
  return { canApply: true, message: null };
};

export const cpiFilterToApiValue = (state: CpiFilterState): CpiFilterApiValue => ({
  operator: OPERATOR_TO_API[state.operator],
  from: parseNumber(state.from) ?? 0,
  to: isBetween(state.operator) ? (parseNumber(state.to) ?? 0) : 0,
});
